import styled from '@mui/material/styles/styled'
import TableCell from '@mui/material/TableCell'

export const LeftCell = styled(TableCell, {
  name: 'LeftCell',
  slot: 'Root',
  skipSx: true,
})`
  border: none;
  font-family: Source Sans Pro;
  font-size: 16px;
  text-align: right;
  padding: 0;
`
